import React, { useEffect, useMemo, useState } from "react";
import {
    Search,
    ChevronDown,
    Users,
    UserCheck,
    UserPlus,
    ShieldCheck,
    Mail,
    Phone,
    MapPin,
    Calendar,
} from "lucide-react";
const USERS = [
    {
        id: "USR-2101",
        name: "Ravi Teja",
        email: "ravi.teja@example.com",
        phone: "+91 98480 12345",
        role: "Operator",
        centre: "Vizag",
        registeredOn: "12 Jul 2026",
        status: "Active",
    },
    {
        id: "USR-2098",
        name: "Lakshmi Devi",
        email: "lakshmi.devi@example.com",
        phone: "+91 90140 55231",
        role: "Designer",
        centre: "Vijayawada",
        registeredOn: "10 Jul 2026",
        status: "Active",
    },
    {
        id: "USR-2094",
        name: "Sandeep Reddy",
        email: "sandeep.reddy@example.com",
        phone: "+91 91821 77654",
        role: "Student",
        centre: "Tirupati",
        registeredOn: "08 Jul 2026",
        status: "Pending",
    },
    {
        id: "USR-2089",
        name: "Meera Iyer",
        email: "meera.iyer@example.com",
        phone: "+91 89197 33421",
        role: "Entrepreneur",
        centre: "Kurnool",
        registeredOn: "05 Jul 2026",
        status: "Active",
    },
    {
        id: "USR-2083",
        name: "Kiran Babu",
        email: "kiran.babu@example.com",
        phone: "+91 93910 44982",
        role: "Operator",
        centre: "Guntur",
        registeredOn: "02 Jul 2026",
        status: "Suspended",
    },
    {
        id: "USR-2077",
        name: "Divya Sri",
        email: "divya.sri@example.com",
        phone: "+91 96760 22187",
        role: "Admin",
        centre: "Nellore",
        registeredOn: "28 Jun 2026",
        status: "Active",
    },
];

const STATUS_STYLES = {
    Active: "bg-green-100 text-green-700",
    Pending: "bg-amber-100 text-amber-700",
    Suspended: "bg-red-100 text-red-700",
};

const ROLE_STYLES = {
    Admin: "bg-indigo-50 text-indigo-600 border border-indigo-200",
    Operator: "bg-blue-50 text-blue-600 border border-blue-200",
    Designer: "bg-purple-50 text-purple-600 border border-purple-200",
    Student: "bg-teal-50 text-teal-600 border border-teal-200",
    Entrepreneur: "bg-slate-50 text-slate-600 border border-slate-200",
};

function StatCard({ icon: Icon, label, value, tone }) {
    return (
        <div className="flex items-center gap-4 rounded-2xl border border-gray-200 bg-white p-5">
            <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tone}`}>
                <Icon className="h-5 w-5" />
            </span>
            <div>
                <p className="text-2xl font-bold text-gray-900">{value}</p>
                <p className="text-sm text-gray-500">{label}</p>
            </div>
        </div>
    );
}

export default function Userdata() {
    const [query, setQuery] = useState("");
    const [roleFilter, setRoleFilter] = useState("All Roles");
    const [statusFilter, setStatusFilter] = useState("All Status");
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);


    // useEffect(() => {
    //     fetchUsers();
    // }, []);

    // const fetchUsers = async () => {
    //     try {
    //         setLoading(true);

    //         const response = await getUsers();

    //         if (response.success) {
    //             const formattedUsers = response.data.map((user) => ({
    //                 id: user.id,
    //                 name: user.name,
    //                 email: user.email,
    //                 phone: user.mobileNumber,
    //                 role: user.role.replace("ROLE_", ""),
    //                 centre: "-",
    //                 registeredOn: new Date(user.createdAt).toLocaleDateString(
    //                     "en-GB",
    //                     {
    //                         day: "2-digit",
    //                         month: "short",
    //                         year: "numeric",
    //                     }
    //                 ),
    //                 status: user.enabled ? "Active" : "Suspended",
    //             }));

    //             setUsers(formattedUsers);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const roles = useMemo(
        () => ["All Roles", ...new Set(USERS.map((u) => u.role))],
        []
    );
    const statuses = useMemo(
        () => ["All Status", ...new Set(USERS.map((u) => u.status))],
        []
    );

    const counts = useMemo(() => {
        const active = USERS.filter((u) => u.status === "Active").length;
        const pending = USERS.filter((u) => u.status === "Pending").length;
        const suspended = USERS.filter((u) => u.status === "Suspended").length;
        return { total: USERS.length, active, pending, suspended };
    }, []);

    const filtered = useMemo(() => {
        return USERS.filter((u) => {
            const matchesQuery =
                query.trim() === "" ||
                [u.name, u.email, u.phone, u.centre].some((field) =>
                    field.toLowerCase().includes(query.trim().toLowerCase())
                );
            const matchesRole = roleFilter === "All Roles" || u.role === roleFilter;
            const matchesStatus = statusFilter === "All Status" || u.status === statusFilter;
            return matchesQuery && matchesRole && matchesStatus;
        });
    }, [query, roleFilter, statusFilter]);

    return (
        <div className="h-screen w-full overflow-y-auto bg-gray-50 scrollbar-hide">
            <style>{`
                .scrollbar-hide::-webkit-scrollbar {
                    display: none;
                }
                .scrollbar-hide {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
            `}</style>

            <div className="p-6">
                {/* Page heading */}
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">Innovators</h1>
                    <p className="mt-1 text-sm text-gray-500">
                        View and manage everyone registered across all centres
                    </p>
                </div>

                {/* Stat cards */}
                <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    <StatCard icon={Users} label="Total users" value={counts.total} tone="bg-indigo-50 text-indigo-500" />
                    <StatCard icon={UserCheck} label="Active" value={counts.active} tone="bg-green-50 text-green-500" />
                    <StatCard icon={UserPlus} label="Pending approval" value={counts.pending} tone="bg-amber-50 text-amber-500" />
                    <StatCard icon={ShieldCheck} label="Suspended" value={counts.suspended} tone="bg-red-50 text-red-500" />
                </div>

                {/* Table card */}
                <div className="w-full rounded-2xl border border-gray-200 bg-white shadow-sm">
                    {/* Header */}
                    <div className="flex flex-col gap-4 border-b border-gray-100 p-6 sm:flex-row sm:items-center sm:justify-between">
                        <div>
                            <h2 className="text-lg font-bold text-gray-900">Registered users</h2>
                            <p className="mt-1 text-sm text-gray-500">
                                {filtered.length} of {USERS.length} users
                            </p>
                        </div>

                        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                            <div className="relative">
                                <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                                <input
                                    type="text"
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder="Search name, email, phone..."
                                    className="w-64 rounded-lg border border-gray-200 bg-gray-50 py-2 pl-9 pr-3 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-gray-300 focus:bg-white"
                                />
                            </div>

                            <div className="relative">
                                <select
                                    value={roleFilter}
                                    onChange={(e) => setRoleFilter(e.target.value)}
                                    className="appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-8 text-sm text-gray-700 outline-none focus:border-gray-300"
                                >
                                    {roles.map((r) => (
                                        <option key={r} value={r}>
                                            {r}
                                        </option>
                                    ))}
                                </select>
                                <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                            </div>

                            <div className="relative">
                                <select
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-8 text-sm text-gray-700 outline-none focus:border-gray-300"
                                >
                                    {statuses.map((s) => (
                                        <option key={s} value={s}>
                                            {s}
                                        </option>
                                    ))}
                                </select>
                                <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <table className="w-full min-w-[1050px] table-fixed border-collapse text-left">
                            <thead>
                                <tr className="bg-gray-50 text-xs uppercase tracking-wide text-gray-400">
                                    <th className="w-[20%] px-6 py-3 font-medium">User</th>
                                    <th className="w-[20%] px-6 py-3 font-medium">Email</th>
                                    <th className="w-[15%] px-6 py-3 font-medium">Phone</th>
                                    <th className="w-[12%] px-6 py-3 font-medium">Role</th>
                                    <th className="w-[12%] px-6 py-3 font-medium">Centre</th>
                                    <th className="w-[13%] px-6 py-3 font-medium">Registered on</th>
                                    <th className="w-[8%] px-6 py-3 font-medium">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((u, idx) => (
                                    <tr
                                        key={u.id}
                                        className={`text-sm ${idx !== filtered.length - 1 ? "border-b border-gray-100" : ""}`}
                                    >
                                        <td className="px-6 py-4">
                                            <div className="flex items-center gap-3">
                                                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-indigo-50 text-xs font-semibold text-indigo-600">
                                                    {u.name
                                                        .split(" ")
                                                        .map((n) => n[0])
                                                        .join("")
                                                        .slice(0, 2)
                                                        .toUpperCase()}
                                                </span>
                                                <div>
                                                    <p className="font-semibold text-gray-900">{u.name}</p>
                                                    <p className="text-xs text-gray-400">{u.id}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-gray-500">
                                            <div className="flex items-center gap-2">
                                                <Mail className="h-4 w-4 shrink-0 text-gray-400" />
                                                <span className="truncate">{u.email}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-gray-600">
                                            <div className="flex items-center gap-2">
                                                <Phone className="h-4 w-4 shrink-0 text-gray-400" />
                                                {u.phone}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <span className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${ROLE_STYLES[u.role] || "bg-gray-50 text-gray-600 border border-gray-200"}`}>
                                                {u.role}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 text-gray-600">
                                            <div className="flex items-center gap-1.5">
                                                <MapPin className="h-4 w-4 shrink-0 text-gray-400" />
                                                {u.centre}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-gray-500">
                                            <div className="flex items-center gap-1.5">
                                                <Calendar className="h-4 w-4 shrink-0 text-gray-400" />
                                                {u.registeredOn}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <span className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${STATUS_STYLES[u.status]}`}>
                                                {u.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}

                                {filtered.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="px-6 py-10 text-center text-sm text-gray-400">
                                            No users match your filters.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}